import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const LocationIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M3.45 11.8077C1.78377 12.5428 0.75 13.5671 0.75 14.7C0.75 16.9368 4.77944 18.75 9.75 18.75C14.7206 18.75 18.75 16.9368 18.75 14.7C18.75 13.5671 17.7162 12.5428 16.05 11.8077M15.15 6.15C15.15 9.80734 11.1 11.55 9.75 14.25C8.4 11.55 4.35 9.80734 4.35 6.15C4.35 3.16766 6.76766 0.75 9.75 0.75C12.7323 0.75 15.15 3.16766 15.15 6.15ZM10.65 6.15C10.65 6.64706 10.2471 7.05 9.75 7.05C9.25294 7.05 8.85 6.64706 8.85 6.15C8.85 5.65294 9.25294 5.25 9.75 5.25C10.2471 5.25 10.65 5.65294 10.65 6.15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
